import Box from '@mui/material/Box'
import { resolveTemplateIcon } from '../lib/templateIconRegistry'

type Props = Readonly<{
  iconKey: string
  size?: number
  /** Figma 37:1800 — faded icon well + glyph on hidden platform cards */
  muted?: boolean
}>

/** Figma tile icon well — background + vector from `templateIconRegistry`. */
export function TemplateIcon({ iconKey, size = 64, muted = false }: Props) {
  const { tileBg, iconSrc, glyphScale = 1 } = resolveTemplateIcon(iconKey)
  const baseGlyph = size <= 48 ? 22 : 26
  const glyph = Math.round(baseGlyph * glyphScale)

  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        borderRadius: '12px',
        bgcolor: tileBg,
        opacity: muted ? 0.4 : 1,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        component="img"
        src={iconSrc}
        alt=""
        sx={{
          width: glyph,
          height: glyph,
          objectFit: 'contain',
        }}
      />
    </Box>
  )
}
